export default "__VITE_ASSET__ScqX$GAs__"